import { Text, View } from 'react-native'
import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineTwopulse,
    },
    variants: {
      size: {
        small: {
          height: theme.sizingSmall,
          minWidth: 168,
          maxWidth: 242,
        },
        medium: {
          height: theme.sizingMedium,
          minWidth: 262,
          maxWidth: 368,
        },
      },
    },
  }
})

export const RatingValue = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.bold,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
    variants: {
      size: {
        small: {
          fontSize: theme.fontSizeThreeandhalfpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreeandhalfpulse,
            theme.lineHeightTiny
          ),
        },
        medium: {
          fontSize: theme.fontSizeFivepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFivepulse,
            theme.lineHeightTiny
          ),
        },
      },
    },
  }
})
